import { useState } from "react";
import { Medal, CaretDown } from "@phosphor-icons/react";

const ROWS = [
  ["1st", 25, "#FFD60A"], ["2nd", 18, "#C0C0C0"], ["3rd", 14, "#CD7F32"],
  ["4th", 11], ["5th", 9], ["6th", 7], ["7th", 6], ["8th", 5],
  ["9th", 4], ["10th", 3], ["11th", 2], ["12th", 1],
];

export function PointsKeyTable() {
  return (
    <div data-testid="points-key">
      <div className="grid grid-cols-1">
        {ROWS.map(([place, pts, medal], i) => (
          <div key={place} className="flex items-center justify-between px-3 py-2 border-b border-border/60" data-testid={`points-row-${i}`}>
            <span className="font-heading font-bold uppercase tracking-wide text-sm flex items-center gap-1.5">
              {medal && <Medal size={16} weight="fill" style={{ color: medal }} />}
              {place}
            </span>
            <span className="font-heading font-black text-lg text-primary tabular-nums">{pts}</span>
          </div>
        ))}
        <div className="flex items-center justify-between px-3 py-2 border-b border-border/60">
          <span className="font-heading font-bold uppercase tracking-wide text-sm text-muted-foreground">13th – 26th</span>
          <span className="font-heading font-black text-lg text-muted-foreground tabular-nums">0</span>
        </div>
        <div className="flex items-center justify-between px-3 py-2 border-b border-border/60">
          <span className="font-heading font-bold uppercase tracking-wide text-sm text-muted-foreground">DNP / No Show</span>
          <span className="font-heading font-black text-lg text-muted-foreground tabular-nums">0</span>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-3 px-3">Points awarded per game — highest total across all games wins. DNP = did not place · NS = no show (suspended players score as No Show).</p>
    </div>
  );
}

export function PointsKeyPanel({ defaultOpen = false, className = "" }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`border border-border rounded-sm bg-card overflow-hidden ${className}`} data-testid="points-key-panel">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="points-key-toggle"
        className="w-full flex items-center justify-between px-4 py-3 hover:bg-white/[0.02] transition-colors"
      >
        <span className="flex items-center gap-2 font-heading font-bold uppercase tracking-wide text-sm">
          <Medal size={16} weight="fill" className="text-[#FFD60A]" /> Points Key
        </span>
        <CaretDown size={18} weight="bold" className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-2 pb-4 pt-1">
        <PointsKeyTable />
      </div>}
    </div>
  );
}
